(function (Drupal, once) {
  "use strict";

  function playYouTube(facade) {
    var id = facade.getAttribute("data-campaign-video");

    if (!id) {
      return;
    }

    var frame = document.createElement("iframe");

    frame.className = "campaign-split__player";
    frame.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
    );
    frame.setAttribute("allowfullscreen", "");
    frame.setAttribute("frameborder", "0");
    frame.title =
      facade.getAttribute("data-campaign-video-title") || Drupal.t("Video");
    frame.src =
      "https://www.youtube.com/embed/" +
      encodeURIComponent(id) +
      "?autoplay=1&playsinline=1&rel=0&cc_load_policy=1&cc_lang_pref=en&color=white&hl=en";

    facade.replaceWith(frame);
  }

  function playUpload(badge) {
    var wrap = badge.parentNode;
    var video = wrap && wrap.querySelector("video");

    if (!video) {
      return;
    }

    badge.remove();

    var started = video.play();

    if (started && typeof started.catch === "function") {
      started.catch(function () {
        video.setAttribute("controls", "");
        video.focus();
      });
    }
  }

  Drupal.behaviors.campaignPlayVideo = {
    attach: function attach(context) {
      once("campaign-video-facade", "[data-campaign-video]", context).forEach(
        function (facade) {
          facade.addEventListener("click", function () {
            playYouTube(facade);
          });
        }
      );

      once("campaign-video-badge", "[data-campaign-video-play]", context).forEach(
        function (badge) {
          badge.addEventListener("click", function () {
            playUpload(badge);
          });
        }
      );

      var links = once("campaign-play-video", "a.js-play-video", context);

      if (!links.length) {
        return;
      }

      var motionOk = !window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches;

      links.forEach(function (link) {
        var split = link.closest(".campaign-split");

        if (!split) {
          return;
        }

        link.addEventListener("click", function (event) {
          event.preventDefault();

          var facade = split.querySelector("[data-campaign-video]");
          var badge = split.querySelector("[data-campaign-video-play]");
          // Qualified: the injected iframe carries the same class.
          var video = split.querySelector("video.campaign-split__player");
          var target = facade || video;

          if (!target) {
            return;
          }

          target.scrollIntoView({
            block: "center",
            behavior: motionOk ? "smooth" : "auto",
          });

          if (facade) {
            playYouTube(facade);
            return;
          }

          if (badge) {
            playUpload(badge);
            return;
          }

          var started = video.play();

          if (started && typeof started.catch === "function") {
            started.catch(function () {
              video.setAttribute("controls", "");
              video.focus();
            });
          }
        });
      });
    },
  };
})(Drupal, once);
